export default {
  component: () => import('./page.vue'),
  path: '/landing',
  name: 'landing',
  meta: {
    title: 'App',
  },
};
